<div class="modal-header">
  <h1 color="black">{{ modalTitle }}</h1>
</div>
<div class="modal-body">
  <div class="row no-padding" *ngIf="modalText">
    <div class="col-md-12">
      {{ modalText }}
    </div>
  </div>
  <div class="row" [ngClass]="modalText ? '' : 'no-padding'">
    <div class="col-md-12">
      <!-- FORM CHANGE TYPE -->
      <div *ngIf="changeType">
        <form [formGroup]="changeTypeRequestForm" autocomplete="off">
          <div class="form-group required" *ngIf="ft && ft.area">
            <label for="area">Área</label>
            <div class="select-wrapper">
              <select
                formControlName="area"
                (change)="changeTypeFunction(changeTypeRequestForm.value.area, 'area')"
                id="area"
              >
                <option [ngValue]="null" selected disabled class="placeholder">Selecione uma Área</option>
                <option
                  *ngFor="let item of allAreas"
                  [selected]="defaultAreaId === item.requestOperationUniqueCode"
                  [value]="item.requestOperationUniqueCode"
                >
                  {{ item.requestOperationTitle }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group required" *ngIf="ft && ft.type1">
            <label for="type1">Tipo 1</label>
            <div class="select-wrapper">
              <select
                formControlName="type1"
                (change)="changeTypeFunction(changeTypeRequestForm.value.type1, 'type1')"
                id="type1"
              >
                <option [ngValue]="null" selected disabled class="placeholder">Selecione um Tipo 1</option>
                <option
                  *ngFor="let item of allTypes1"
                  [selected]="defaultType1Id === item.requestOperationUniqueCode"
                  [value]="item.requestOperationUniqueCode"
                >
                  {{ item.requestOperationTitle }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group required" *ngIf="ft && ft.type2">
            <label for="type2">Tipo 2</label>
            <div class="select-wrapper">
              <label>
                <select
                  formControlName="type2"
                  (change)="changeTypeFunction(changeTypeRequestForm.value.type2, 'type2')"
                  id="type2"
                >
                  <option [ngValue]="null" selected disabled class="placeholder">Selecione um Tipo 2</option>
                  <option
                    *ngFor="let item of allTypes2"
                    [selected]="defaultType2Id === item.requestOperationUniqueCode"
                    [value]="item.requestOperationUniqueCode"
                  >
                    {{ item.requestOperationTitle }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="form-group" [ngClass]="{ required: voltageLevelRequired === true }" *ngIf="showVoltageField">
            <label for="voltage">Nível de tensão</label>
            <div class="select-wrapper">
              <select formControlName="voltage" id="voltage">
                <option [ngValue]="null" selected class="placeholder">Selecione um nível de tensão</option>
                <option
                  *ngFor="let item of voltageLevelList"
                  [selected]="defaultvoltageLevelId === item.voltageLevelUniqueCode"
                  [value]="item.voltageLevelUniqueCode"
                >
                  {{ item.voltageLevelName }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="form-group"
            *ngIf="ft && ft.notes"
            [ngClass]="{ required: ft.notes.errors && ft.notes.errors?.required === true }"
          >
            <label for="notes">Notas Internas</label>
            <textarea
              formControlName="notes"
              class="form-control"
              id="notes"
              placeholder="Insira a sua nota interna"
            ></textarea>
          </div>
        </form>
      </div>
      <!-- END FORM CHANGE TYPE -->
      <!-- FORM CHANGE STATUS -->
      <div *ngIf="changeStatus">
        <form [formGroup]="changeStatusRequestForm" autocomplete="off">
          <div class="form-group required" *ngIf="fs && fs.status">
            <label for="status">Estado</label>
            <div class="select-wrapper">
              <select
                formControlName="status"
                (change)="changeStatusFunction(changeStatusRequestForm.value.status)"
                id="status"
              >
                <option [ngValue]="defaultStatusId" selected disabled class="placeholder">
                  {{ defaultStatus }}
                </option>
                <option *ngFor="let item of allStatus" [value]="item.key">
                  {{ item.value }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group required" *ngIf="fs && fs.notes">
            <label for="notes2">{{ notesLabel }}</label>
            <textarea
              formControlName="notes"
              class="form-control"
              id="notes2"
              placeholder="Insira {{ notesPlaceholder }}"
            ></textarea>
          </div>
          <app-edp-attachments
            [fileList]="fileList"
            [insertAttachment]="true"
            [maxFileSize]="15728640"
            (outputFileList)="synchronizeFiles($event)"
            (invalidFile)="fileIsInvalid($event)"
            *ngIf="showAttachments"
          ></app-edp-attachments>
          <div class="form-group alert alert-danger text-center" *ngIf="fileTooLarge">
            Ficheiro é superior ao tamanho máximo permitido (15MB)
          </div>
        </form>
      </div>
      <!-- END FORM CHANGE STATUS -->
      <!-- ATTACH LIST -->
      <div *ngIf="openListAttachments" class="attachments">
        <ul>
          <li *ngFor="let attach of attachList">
            <i
              color="black"
              tabindex="0"
              (click)="downloadFile(attach)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && downloadFile(attach)"
              class="glyphicon glyphicon-paperclip cursor-pointer"
            ></i>
            <a
              class="cursor-pointer"
              color="black"
              tabindex="0"
              (click)="downloadFile(attach)"
              (keydown)="($event.key === 'Enter' || $event.key === ' ') && downloadFile(attach)"
              >{{ attach.fileName }}</a
            >
          </li>
        </ul>
      </div>
      <!-- END ATTACH LIST -->
      <!-- REOPEN REQUEST -->
      <div *ngIf="reOpen">
        <form [formGroup]="reOpenRequestForm" autocomplete="off">
          <div class="form-group required" *ngIf="fr && fr.notes">
            <label for="notes3">Resposta</label>
            <textarea
              formControlName="notes"
              class="form-control"
              id="notes3"
              placeholder="Insira a sua resposta"
            ></textarea>
          </div>
        </form>
      </div>
      <!-- END REOPEN REQUEST -->
    </div>
  </div>
</div>
<div class="dsm34--d-flex dsm34--justify-content-center dsm34--mt-md">
  <button type="button" class="edp-btn btn-gray" (click)="close()" *ngIf="btnCancelText" mat-dialog-close>
    {{ btnCancelText }}
  </button>
  <button
    type="button"
    class="edp-btn btn-yellow"
    (click)="confirmType()"
    *ngIf="btnConfirmText && changeType"
    [disabled]="changeTypeRequestForm.pristine || changeTypeRequestForm.invalid"
  >
    {{ btnConfirmText }}
  </button>
  <button
    type="button"
    class="edp-btn btn-yellow"
    (click)="confirmStatus()"
    *ngIf="btnConfirmText && changeStatus"
    [disabled]="changeStatusRequestForm.pristine || changeStatusRequestForm.invalid || checkDefaultValues()"
  >
    {{ btnConfirmText }}
  </button>
  <button
    type="button"
    class="edp-btn btn-yellow"
    (click)="confirmReOpen()"
    *ngIf="btnConfirmText && reOpen"
    [disabled]="reOpenRequestForm.pristine || reOpenRequestForm.invalid"
  >
    {{ btnConfirmText }}
  </button>
  <button type="button" class="edp-btn btn-yellow" (click)="confirmUser()" *ngIf="btnConfirmText && changeUser">
    {{ btnConfirmText }}
  </button>
</div>
